import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Head from "next/head";
import { defaultMetatags } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function createValue(value, key) {
  if (value) {
    return value;
  } else {
    const defaultValue = key.split(".").reduce((acc, v) => acc === null || acc === void 0 ? void 0 : acc[v], defaultMetatags === null || defaultMetatags === void 0 ? void 0 : defaultMetatags["vod"]);
    return defaultValue;
  }
}
export function MetaTag(_ref) {
  let {
    title,
    keywords,
    description
  } = _ref;
  const titleValue = createValue(title, "title", "vod");
  const keywordsContent = createValue(keywords, "keywords");
  const descriptionContent = createValue(description, "description");
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("title", {
      children: titleValue
    }, "title"), /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: keywordsContent
    }, "keywords"), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: descriptionContent
    }, "description")]
  });
}
export function Og(_ref2) {
  let {
    type,
    title,
    description,
    url,
    image
  } = _ref2;
  const titleContent = createValue(title, "og.title");
  const ogurl = (() => {
    if (true) {
      return window.location.href;
    } else {
      return url || defaultMetatags["vod"].og.url;
    }
  })();
  const descriptionContent = createValue(description, "og.description");
  const imageContent = createValue(image, "og.image");
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("meta", {
      property: "og:title",
      content: titleContent
    }, "ogtitle"), /*#__PURE__*/_jsx("meta", {
      property: "og:url",
      content: ogurl
    }, "ogurl"), /*#__PURE__*/_jsx("meta", {
      property: "og:type",
      content: type
    }, "ogtype"), /*#__PURE__*/_jsx("meta", {
      property: "og:description",
      content: descriptionContent
    }, "ogdescription"), /*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: imageContent
    }, "ogimage")]
  });
}
export function TwitterCard(_ref3) {
  let {
    title,
    description,
    card,
    image
  } = _ref3;
  const titleContent = createValue(title, "twitter.title");
  const descriptionContent = createValue(description, "twitter.description");
  const imageContent = createValue(image, "twitter.image");
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("meta", {
      name: "twitter:title",
      content: titleContent
    }, "twittertitle"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:description",
      content: descriptionContent
    }, "twitterdescription"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: card
    }, "twittercard"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:image",
      content: imageContent
    }, "twitterimage")]
  });
}
export function Robots(_ref4) {
  let {
    content
  } = _ref4;
  if (!content) return null;
  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("meta", {
      name: "robots",
      content: content
    }, "robots")
  });
}
export function CanonicalUrl(_ref5) {
  let {
    href
  } = _ref5;
  if (!href) return null;
  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("link", {
      rel: "canonical",
      href: href
    })
  });
}
export default function MetaTags(_ref6) {
  let {
    title,
    keywords,
    description,
    og,
    twitter,
    robots,
    canonicalUrl
  } = _ref6;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MetaTag, {
      title,
      keywords,
      description
    }), /*#__PURE__*/_jsx(Og, _objectSpread({}, _objectSpread({
      description
    }, og))), /*#__PURE__*/_jsx(TwitterCard, _objectSpread({}, _objectSpread(_objectSpread({}, twitter), {}, {
      description
    }))), /*#__PURE__*/_jsx(Robots, {
      content: robots
    }), /*#__PURE__*/_jsx(CanonicalUrl, {
      href: canonicalUrl
    })]
  });
}